import classNames from "classnames";
import { CloseCrossIcon } from "@/shared/icons";
import type { FC } from "react";
import type { BookmarkTab, BookmarkTabsProps } from "../types";
import { AppButton } from "../../AppButton";
import styles from "../styles.module.scss";

type Props = {
  onChange: BookmarkTabsProps["onChange"];
  tab: BookmarkTab;
  activeClassName?: BookmarkTabsProps["activeTabClassName"];
  isEditable: BookmarkTabsProps["isEditable"];
  active: boolean;
  tabClassName?: BookmarkTabsProps["tabClassName"];
  onCancelTab: () => void;
};

export const Tab: FC<Props> = ({
  onChange,
  onCancelTab = () => "",
  tab,
  isEditable,
  active,
  activeClassName,
  tabClassName,
}) => {
  return (
    <div
      onClick={(e) => {
        if (tab.disabled) return;
        e.stopPropagation();
        onChange(tab.value);
      }}
      className={classNames(
        styles.tab,
        {
          [classNames(styles["active-tab"], activeClassName)]: active,
          [styles.disabled]: tab.disabled,
        },
        tabClassName,
      )}
      key={tab.value}
    >
      <div className={styles.inner}>
        {tab.label}
        {isEditable && (
          <AppButton
            className={styles["close-button"]}
            onClick={(e) => {
              e.stopPropagation();
              onCancelTab();
            }}
          >
            <CloseCrossIcon />
          </AppButton>
        )}
      </div>
    </div>
  );
};
